export default __webpack_public_path__ + "static/media/watch_3.318bc60a.jpg";